import { useState, useEffect } from 'react';
import blow from "../assets/image/bolwing-arrow.png";
import rocket from "../assets/image/rocket.png";
import money from "../assets/image/money.png";
import Team1 from "../assets/image/Frame1.png";
import ArrowBg from "../component/ArrowBg";
import Whitearow from "../assets/arrow3.png";
import bigrow from "../assets/whitearow2.png";
import line from "../assets/line3.png";
import { useNavigate } from 'react-router-dom';
import Vector from "../assets/Vector.png";


export default function Hero() {
 const navigate = useNavigate()
  const [letterStates, setLetterStates] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const text = "Get quick, no-fuss loans for your business";
    const letters = text.split('');
    
    // Initialize all letters as not visible
    setLetterStates(new Array(letters.length).fill(false));
    
    setTimeout(() => setLoaded(true), 100);
    
    // Animate each letter sequentially with blur effect
    letters.forEach((_, index) => {
      setTimeout(() => {
        setLetterStates(prev => {
          const newState = [...prev];
          newState[index] = true;
          return newState;
        });
      }, 500 + (index * 40)); // Each letter appears 40ms after previous
    });
  }, []);

  const renderAnimatedText = (text, startIndex = 0) => {
    return text.split(' ').map((word, wordIndex) => {
      const wordStartIndex = startIndex + text.split(' ').slice(0, wordIndex).join(' ').length + wordIndex;
      
      return (
        <span key={wordIndex} className="inline-block mr-[0.3em]">
          {word.split('').map((letter, letterIndex) => {
            const currentIndex = wordStartIndex + letterIndex;
            return (
              <span
                key={letterIndex}
                className={`inline-block transition-all duration-500 ${
                  letterStates[currentIndex]
                    ? 'opacity-100 blur-0 translate-y-0'
                    : 'opacity-0 blur-md translate-y-4'
                }`}
              >
                {letter}
              </span>
            );
          })}
        </span>
      );
    });
  };

  return (
    <>
      <style>{`
        @keyframes slideDownBg {
          from {
            transform: translateY(-30%);
          }
          to {
            transform: translateY(0);
          }
        }

        @keyframes floatIn {
          from {
            transform: translateY(30px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        @keyframes diagonalSlide {
          from {
            transform: translate(-100%, 100%);
            opacity: 0;
          }
          to {
            transform: translate(0, 0);
            opacity: 1;
          }
        }

        @keyframes rotateIn {
          from {
            transform: rotate(90deg) scale(0.3);
            opacity: 0;
          }
          to {
            transform: rotate(70deg) scale(1);
            opacity: 0.7;
          }
        }

        @keyframes slideFromLeft {
          from {
            transform: translateX(-150px) rotate(10deg) scale(0.5);
            opacity: 0;
          }
          to {
            transform: translateX(0) rotate(10deg) scale(1);
            opacity: 1;
          }
        }

        @keyframes slideFromRight {
          from {
            transform: translateX(150px) rotate(335deg) scale(0.5);
            opacity: 0;
          }
          to {
            transform: translateX(0) rotate(335deg) scale(1);
            opacity: 1;
          }
        }

        @keyframes rotateSlide {
          from {
            transform: translateX(150px) rotate(285deg) scale(0.5);
            opacity: 0;
          }
          to {
            transform: translateX(0) rotate(285deg) scale(1);
            opacity: 1;
          }
        }

        @keyframes slideFromBottom {
          from {
            transform: translateY(100px) rotate(13deg) scale(0.5);
            opacity: 0;
          }
          to {
            transform: translateY(0) rotate(13deg) scale(1);
            opacity: 1;
          }
        }

        @keyframes scaleIn {
          from {
            transform: scale(0.8);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }

        @keyframes buttonFloat {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-5px);
          }
        }

        .hero-bg-animate {
          animation: slideDownBg 1s ease-out;
        }

        .text-float {
          animation: floatIn 0.8s ease-out;
        }

        .button-animate {
          animation: floatIn 1s ease-out 2s both;
        }

         .object-1 {
          animation: slideFromLeft 1s ease-out 0.5s both;
        }

        .object-2 {
          animation: slideFromTop 1s ease-out 0.7s both;
        }

        .object-3 {
          animation: slideFromBottom 1s ease-out 0.9s both;
        }

        .object-4 {
          animation: slideFromRight 1.2s ease-out 1.1s both;
        }

        .image-card-animate {
          animation: diagonalSlide 1s ease-out 0.8s both;
        }

        .arrow-top-left {
          animation: rotateIn 1s ease-out 0.5s both;
        }

        .rocket-animate {
          animation: slideFromLeft 1.2s ease-out 1s both;
        }

        .money-bottom-right {
          animation: slideFromRight 1s ease-out 1.2s both;
        }

        .arrow-mid-right {
          animation: rotateSlide 1s ease-out 1.4s both;
        }

        .money-bottom-left {
          animation: slideFromBottom 1s ease-out 1.6s both;
        }

        .bg-gradient-radial {
          background: radial-gradient(ellipse at top center, #149D64 0%, #0B6351 10%);
        }

        /* DEFAULT State */
        .button-default {
          box-shadow:
            0 0 0 0.9px #47ffd48e,
            inset 0 0 20px rgba(25, 180, 140, 1.0),
            inset 0 0 10px rgba(42, 157, 114, 0.7);
        }

        /* HOVER State */
        .button-default:hover {
          box-shadow:
            0 0 0 4px #47ffd48e,
            inset 0 0 0px rgba(0, 0, 0, 0),
            inset 0 0 0px rgba(0, 0, 0, 0);
        }

        /* Decorative elements subtle float animation */
        .float-gentle {
          animation: floatGentle 3s ease-in-out infinite;
        }

        @keyframes floatGentle {
          0%, 100% {
            transform: translateY(0) rotate(var(--rotate, 0deg));
          }
          50% {
            transform: translateY(-10px) rotate(var(--rotate, 0deg));
          }
        }

        .float-gentle-2 {
          animation: floatGentle2 4s ease-in-out infinite;
        }

        @keyframes floatGentle2 {
          0%, 100% {
            transform: translateY(0) rotate(var(--rotate, 0deg));
          }
          50% {
            transform: translateY(-15px) rotate(var(--rotate, 0deg));
          }
        }
      `}</style>

      <section
        id="home"
        className="
          w-full 
          bg-emerald-700
          rounded-bl-[40px] rounded-br-[40px]
          overflow-hidden relative
          hero-bg-animate

          /* Mobile */
          pl-0  pr-0 pt-40

          sm:pl-[1px] sm:pr-[1px] sm:pt-[120px] sm: pb-[120px]

          /* Medium (md) */
          md:pr-[28px] md:pl-[30px] md:pt-[120px] md:pb-[120px]

          /* Large (lg) */
          lg:pt-[170px] lg:pb-[200px] lg:pr-[120px] lg:pl-[40px] lg:rounded-bl-[50px] lg:rounded-br-[50px]
        "
        style={{
          width: "100%",
          height: "100%",
          background:
            "radial-gradient(ellipse at top center, #149D64 0%, #0B6351 100%)",
        }}
      >
        <div className='relative w-full '>
        <div className="
          max-w-[1200px] mx-auto pr-[8px]
          sm:pr-[8px] pl-[8px]  
          md:px-2 relative z-10 md:pr-[0px]
          text-center md:text-left
          lg: px-10 lg:
        ">
          <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr] gap-20  items-center sm:gap-20 md:gap-6 lg:gap-6">

            {/* LEFT CONTENT */}
            <div>
              <div className="gap-6
                sm: leading-[44px]
                md:leading-[52px]
                lg:leading-[82px]
                xl:leading-[87px]
              ">
                <h1
                  className="
                    font-inter font-normal text-white tracking-[-1.5px] w-full
                    text-[32px] 
                    sm: text-[34px] sm:leading-[44px]
                    md:text-[40px] md:leading-[52px]
                    lg:text-[60px] lg:leading-[65px]
                    xl:text-[60px] xl:leading-[78px]
                  "
                >
                  {renderAnimatedText("Get quick, no-fuss loans", 0)}
                </h1>
                <h1 className="
                  font-inter font-extrabold text-white tracking-[-1.5px] w-full
                  text-[32px] 
                  sm: text-[34px] sm:leading-[44px]
                  md:text-[45px] md:leading-[52px]
                  lg:text-[60px] lg:leading-[65px]
                  xl:text-[60px] xl:leading-[78px]
                  mt-2
                ">
                  {renderAnimatedText("for your business", 10)}
                </h1>
              </div>

              <p
                className={`
                  font-inter font-normal text-white mb-8 mt-8
                  max-w-[523px] mx-auto md:mx-0 sm:max-w-[510px] md:max-w-[523px] lg:v
                  text-[14px] leading-[22px]
                  sm:text-[15px] sm:leading-[24px]
                  md:text-[16px] md:leading-[26px]
                  lg:text-[17px] lg:leading-[28px]
                  text-float
                `}
                style={{ animationDelay: '1.8s', animationFillMode: 'both' }}
              >
                No delays. No hidden terms. Just fast and flexible finance when you need it the most.
              </p>

              <button
                className="
                  relative
                  text-xl font-semibold text-white
                  rounded-[18px]
                  w-[176px] h-[56px]
                  bg-black
                  button-default
                  button-animate
                  hover:text-[#2a9d72]
                  cursor-pointer
                  transition-all duration-300
                  z-20
                "
onClick={() => navigate('/contact')}

              >
                Let's Start
              </button>
            </div>

            {/* RIGHT IMAGE CARD */}
           <div className="relative flex justify-center md:justify-end sm:pr-[14px] sm:pl-[14px] md:pr-[90px] lg:pr-0 lg:pl-0 image-card-animate">
  <div className="max-w-[282px] max-h-[321px] min-w-[279px] min-h-[308px] sm:max-w-[362px] sm:max-h-[401px] md:max-w-[362px] md:max-h-[401px]
    rounded-tl-[110px] rounded-tr-[30px] rounded-br-[30px] rounded-bl-[30px]
    bg-[#2a9d72] overflow-visible relative
    transition-transform duration-500 
  ">
    {/* Top-right white arrow vector */}
    <img 
      src={Whitearow} 
      alt="" 
      className="absolute -top-[35%] -right-[45%] w-[500px] sm:w-[650px] md:w-[750px] lg:w-[860px] opacity-70 z-0" 
    />
    
    {/* Bottom-left green vector */}
    <img 
      src={Vector} 
      alt="" 
      className="absolute -bottom-[60%] -left-[76.5%] w-[600px] sm:w-[750px] md:w-[950px] lg:w-[1060px] opacity-70 z-0 rotate-[5deg]" 
    />

    <img 
      src={Team1} 
      alt="" 
      className="w-full h-full rounded-[30px] object-cover relative z-10" 
    />
    
    <div className="absolute max-w-[362px] max-h-[401px] w-full h-full top-0 bottom-0 left-0 right-0 rounded-tl-[110px] rounded-tr-[30px] rounded-br-[30px] rounded-bl-[30px] bg-[#2a9d72] overflow-visible pointer-events-none"> 
      <img 
        src={Team1} 
        alt="" 
        className="absolute bottom-0 left-0 right-0 top-0 rounded-[30px] opacity-100 z-0" 
      />
    </div>
  </div>
</div>

          </div>
        </div>


        </div>

        {/* Decorative Elements */}
            <ArrowBg className="absolute top-50 sm:top-50 md:-top-1/2 lg:top-50" />

        {/* Top-left glowing arrow */}
        <img 
          src={blow} 
          alt="" 
          className="absolute opacity-70 rotate-[70deg] blur-sm lg: top-20 left-10 w-32 md: top-20 left-10 w-32 " 
          style={{'--rotate': '70deg'}}
        />

        {/* Bottom-left rocket*/}
        <img 
          src={rocket} 
          alt="" 
          className="absolute object-contain opacity-100
            bottom-5 -left-10 w-32 h-32
            sm: bottom-[44%] sm: -left-[14%] sm: w-44 sm: h-44 sm: rotate-[10deg]
            md:bottom-0 md:-left-16 md:w-44 md:h-44 md:rotate-[10deg]
            lg:bottom-11 lg:-left-20 lg:w-60 lg:h-60
           object-1
          "
          style={{'--rotate': '10deg'}}
        />

        {/* Bottom-right money icon */}
        <img 
          src={money} 
          alt="" 
          className="absolute opacity-100 blur-[2px] rotate-[335deg] object-contain w-full h-full max-w-[218px] max-h-[128px] 
            -bottom-[6%] right-[0px]
            sm:right-[0px] 
            md:right-[0px] 
            lg:right-[210px]
            object-3
          "
          style={{'--rotate': '335deg'}}
        />

        {/* Mid-right big diagonal shape */}
        <div 
         
          className="absolute rotate-[285deg] object-contain w-full h-full max-w-[232px] max-h-[232px]
            bottom-40 -right-[10%] 
            sm:-right-[10%]
            md:-right-[10%] 
            lg:-right-[8%]
            object-4
          "
          style={{'--rotate': '285deg'}}
        > <img 
          src={blow} 
          alt="" 
          className=" w-full h-full
            rotate-[285deg]
          "
        />
        </div>

        {/* Bottom-left money icon */}
        <img 
          src={money} 
          alt="" 
          className="absolute rotate-[13deg] object-contain w-full h-full max-w-[248px] max-h-[248px]
            -bottom-[12%] right-[50%]
            sm:-bottom-[10%]
            md:-bottom-[18%]
            lg:-bottom-[12%]
            object-3
          " 
          style={{'--rotate': '13deg'}}
        />

      </section>
    </>
  );
}